module.exports = __webpack_public_path__ + "static/images/campaigns-on-consumer.264bbddecb5197acd0b803d0be49c38b.png";